export interface ResourceCard {
  id: string;
  to: string;
  image: string;
}

export const resources: ResourceCard[] = [
  {
    id: "spreadsheet",
    to: "/usfans-spreadsheet-guide",
    image:
      "https://readdy.ai/api/search-image?query=Laptop%20screen%20showing%20a%20clean%20spreadsheet%20with%20colorful%20category%20rows%20on%20a%20minimal%20desk%20with%20a%20plant%2C%20soft%20natural%20light%2C%20modern%20productivity%20photography%20with%20high%20detail&width=800&height=600&seq=res-spreadsheet-01&orientation=landscape",
  },
  {
    id: "directory",
    to: "/article/usfans-creator-directory",
    image:
      "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20an%20organized%20list%20and%20sticky%20notes%20on%20a%20bright%20clean%20desk%20with%20a%20coffee%20cup%2C%20soft%20daylight%2C%20minimal%20photography%20with%20high%20detail&width=800&height=600&seq=res-directory-01&orientation=landscape",
  },
  {
    id: "reviews",
    to: "/article/usfans-review",
    image:
      "https://readdy.ai/api/search-image?query=Person%20reading%20product%20reviews%20on%20a%20tablet%20beside%20a%20pair%20of%20sneakers%20and%20shopping%20bags%2C%20soft%20warm%20light%2C%20minimal%20lifestyle%20photography%20with%20high%20detail&width=800&height=600&seq=res-reviews-01&orientation=landscape",
  },
  {
    id: "comparisons",
    to: "/article/usfans-creator-spreadsheet",
    image:
      "https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20showing%20comparison%20tables%20on%20a%20clean%20workspace%2C%20soft%20natural%20light%2C%20minimal%20analytics%20photography%20with%20high%20detail&width=800&height=600&seq=res-comparisons-01&orientation=landscape",
  },
  {
    id: "safety",
    to: "/article/usfans-safety",
    image:
      "https://readdy.ai/api/search-image?query=Shield%20and%20lock%20icon%20on%20a%20smartphone%20screen%20beside%20a%20notebook%20on%20a%20clean%20desk%2C%20soft%20light%2C%20minimal%20security%20photography%20with%20high%20detail&width=800&height=600&seq=res-safety-01&orientation=landscape",
  },
  {
    id: "guides",
    to: "/article/usfans-faq",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20books%20and%20a%20tablet%20with%20an%20open%20guide%20page%20on%20a%20minimal%20desk%20with%20a%20plant%2C%20soft%20natural%20light%2C%20cozy%20reading%20photography%20with%20high%20detail&width=800&height=600&seq=res-guides-01&orientation=landscape",
  },
];